/**
 * {
    "status": "string",
    "message": "string",
    "errors": [
        {
            "message": "string",
            "fieldName": "string",
            "fieldValue": "string"
        },
        ...
    ]
}
 */
/**
 * This approach allows without any troubles handle multiple errors for fields
 */
export class RequestStatus {
  constructor(loading = false, loaded = false, error = null) {
    this.loading = loading;
    this.loaded = loaded;
    this.error = error;
  }
}
